import { isCommonMessageFormat, isEmailCMF
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/cmfComparators';
import { getSenderId, getSenderType, getMessageSendFailure
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getFromSenderName, getOriginalFromSenderEmail, getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
// @ts-expect-error module not typed
import { isThreadComment } from 'conversations-message-history/comment-message/operators/cmComparators';
import { getMessage, getAllowRetry } from 'conversations-message-history/unpublished-messages/operators/getters';
import { Set as ImmutableSet } from 'immutable';
import { PureComponent } from 'react';
import styled from 'styled-components';
import { isSenderPresent } from 'conversations-message-history/senders/operators/isSenderPresent';
// @ts-expect-error module not typed
import CommentMessageBody from '../comment/CommentMessageBody';
import { AGENT } from 'conversations-message-history/constants/messageUses';
import { COMMENT } from 'conversations-message-history/constants/tileMessageUses';
import PrimaryMessageContentSection from '../primary-message/components/PrimaryMessageContentSection';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getData } from 'conversations-message-history/senders/operators/getters';
// @ts-expect-error module not typed
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
// @ts-expect-error module not typed
import { senderEmailDoesNotMatchVisitor } from 'conversations-message-history/senders/operators/senderEmailDoesNotMatchVisitor';
import Sender from 'conversations-message-history/senders/records/Sender';
// @ts-expect-error module not typed
import { getSenderIdOrVid } from 'conversations-message-history/common-message-format/operators/getSenderIdOrVid';
import TileMessage from '../tile-message/TileMessage';
import FailedToPublishMessageText from './FailedToPublishMessageText';
import CommonMessageContent from '../common-message/CommonMessageContent';
// @ts-expect-error module not typed
import CommonMessageSection from './CommonMessageSection';
// @ts-expect-error module not typed
import CommonAttachmentsFooter from './CommonAttachmentsFooter';
import { getMessageRecipientNames } from '../common-message/operators/getMessageRecipientNames';
import RecipientLine from '../common-message/RecipientLine';
import SlottedMessage from '../slotted-message/SlottedMessage';
import FullSenderName from '../senders/components/FullSenderName';
import CommonMessageHeaderPopover from '../common-message-popover/CommonMessageHeaderPopover';
import { ChannelIcon } from '../atoms/ChannelIcon';

// @ts-expect-error module not typed

import SenderAvatar from '../avatar/SenderAvatar';
import { jsx as _jsx } from "react/jsx-runtime";
const FailedHeaderWrapper = styled.div.withConfig({
  displayName: "FailedToPublishMessage__FailedHeaderWrapper",
  componentId: "sc-1izuuwy-0"
})(["line-height:24px;"]);
const FailedToPublishMessageBody = ({
  genericChannelId,
  message,
  fileAttachments,
  renderMessageContent
}) => /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
  canExpand: true,
  genericChannelId: genericChannelId,
  isLastMessage: true,
  children: /*#__PURE__*/_jsx(CommonMessageSection, {
    message: message,
    fileAttachments: fileAttachments,
    renderMessageContent: renderMessageContent
  })
});
FailedToPublishMessageBody.displayName = 'FailedToPublishMessageBody';
const FailedToPublishMessageFooter = props => /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
  children: /*#__PURE__*/_jsx(CommonAttachmentsFooter, Object.assign({}, props))
});
FailedToPublishMessageFooter.displayName = 'FailedToPublishMessageFooter';
class FailedToPublishMessage extends PureComponent {
  constructor(...args) {
    super(...args);
    this.renderPrimaryMessageContent = () => {
      const {
        fetchReplies,
        message: failedToPublishMessage,
        messageReplyIsLoading,
        plainTextMode = false
      } = this.props;
      const message = getMessage(failedToPublishMessage);
      const genericChannelId = getGenericChannelId(message);
      return /*#__PURE__*/_jsx(CommonMessageContent, {
        fetchReplies: fetchReplies,
        message: message,
        messageReplyIsLoading: messageReplyIsLoading,
        plainTextMode: plainTextMode,
        genericChannelId: genericChannelId
      });
    };
    this.renderFailedHeader = () => {
      const {
        message: failedToPublishMessage,
        onRepublish,
        connectedAccounts
      } = this.props;
      const message = getMessage(failedToPublishMessage);
      return (
        /*#__PURE__*/
        // @bend-expect trellis-tokenized
        _jsx(FailedHeaderWrapper, {
          children: /*#__PURE__*/_jsx(FailedToPublishMessageText, {
            message: message,
            onRepublish: onRepublish,
            connectedAccounts: connectedAccounts
          })
        })
      );
    };
  }
  render() {
    const {
      channelName,
      connectedAccounts,
      fileAttachments,
      friendlyNames,
      message: failedToPublishMessage,
      onClickAvatar,
      onRepublish,
      positionDescriptors,
      senders,
      senderName,
      vid,
      ungatedForThreadMessagesUIImprovements
    } = this.props;
    const message = getMessage(failedToPublishMessage);
    const commonMessageFormat = isCommonMessageFormat(message);
    const genericChannelId = getGenericChannelId(message);
    if (commonMessageFormat) {
      const recipientNames = getMessageRecipientNames({
        message,
        friendlyNames
      });
      const senderId = getSenderId(message);
      const updatedSenderId = getSenderIdOrVid({
        message,
        vid,
        senderId
      });
      const senderType = getSenderType(message);
      const asyncSender = findSender(updatedSenderId, senderType, senders);
      const present = isSenderPresent(updatedSenderId, senderType, ImmutableSet());
      let sender = getData(asyncSender);
      const fromSenderName = getFromSenderName(message) || null;
      if (!sender || senderEmailDoesNotMatchVisitor({
        sender,
        message
      })) {
        sender = Sender({
          senderType,
          firstName: fromSenderName,
          email: getOriginalFromSenderEmail(message) || null
        });
      }
      const isLoading = isSenderLoading(asyncSender);
      const sendFailure = getMessageSendFailure(message);
      const messageRetryable = sendFailure ? sendFailure.get('retryable') : false;
      const shouldDisplayByline = isEmailCMF(message);
      const allowRetry = getAllowRetry(failedToPublishMessage) && messageRetryable;
      return /*#__PURE__*/_jsx(SlottedMessage, {
        container: {
          componentProps: {
            positionDescriptors,
            use: AGENT,
            ungatedForThreadMessagesUIImprovements
          }
        },
        avatar: {
          Component: SenderAvatar,
          isLoading,
          componentProps: {
            onClick: onClickAvatar,
            sender,
            present,
            size: 'sm'
          }
        },
        title: {
          isLoading,
          loaderProps: {
            use: 'default'
          },
          Component: FullSenderName,
          componentProps: {
            sender,
            senderName,
            'data-test-id': 'sender-name'
          }
        },
        channel: {
          renderCustom: () => channelName || /*#__PURE__*/_jsx(ChannelIcon, {
            genericChannelId: genericChannelId
          })
        },
        detailsPopover: {
          Component: CommonMessageHeaderPopover,
          componentProps: {
            message,
            sender,
            isSenderLoading: isLoading
          }
        },
        byline: shouldDisplayByline ? {
          Component: RecipientLine,
          componentProps: {
            recipientNames
          }
        } : null,
        body: {
          Component: FailedToPublishMessageBody,
          componentProps: {
            genericChannelId,
            message,
            fileAttachments,
            renderMessageContent: this.renderPrimaryMessageContent
          }
        },
        footerBody: {
          Component: FailedToPublishMessageFooter,
          componentProps: {
            allowRetry,
            message,
            onRepublish,
            connectedAccounts,
            fileAttachments,
            'data-test-id': 'file-attachments-footer'
          }
        },
        annotation: {
          Component: FailedToPublishMessageText,
          componentProps: {
            allowRetry,
            message,
            onRepublish,
            connectedAccounts
          }
        }
      });
    }
    if (isThreadComment(message)) {
      return /*#__PURE__*/_jsx(TileMessage, {
        use: COMMENT,
        positionDescriptors: positionDescriptors,
        children: /*#__PURE__*/_jsx(CommentMessageBody, {
          message: message,
          onClickAvatar: onClickAvatar,
          senders: senders,
          renderHeaderMetadata: this.renderFailedHeader
        })
      });
    }
    return null;
  }
}
FailedToPublishMessage.displayName = 'FailedToPublishMessage';
export default FailedToPublishMessage;